import React, { forwardRef } from "react";
import "./OrderPrint.scss";

const OrderPrint = forwardRef(({ sendData }, ref) => {
  // ==================== محاسبه مجموع برای محصولات ====================
  const productTotal = sendData?.products?.reduce(
    (acc, product) => ({
      gh_masraf: acc.gh_masraf + Number(product.gh_masraf) * Number(product.te),
      gh_forosh: acc.gh_forosh + Number(product.gh_forosh) * Number(product.te),
      te: acc.te + Number(product.te),
    }),
    { gh_masraf: 0, gh_forosh: 0, te: 0 },
  );

  // ==================== محاسبه مجموع برای خدمات ====================
  const serviceTotal = sendData?.services?.reduce(
    (acc, service) => acc + Number(service.price),
    0,
  );

  // ==================== محاسبه مقادیر مجموع سفارش‌ها ====================
  const totalOrder = productTotal.gh_forosh + serviceTotal;
  const tax = totalOrder * 0.1;
  const totalPayable = totalOrder + tax;

  // ==================== محاسبه مقادیر مجموع تحویل‌شده ====================
  const fiTahvil = Number(sendData?.sumTahvil?.fi) || 0;
  const taxTahvil = Number(sendData?.sumTahvil?.tax) || 0;
  const totalPayableTahvil = fiTahvil + taxTahvil;
  const kasriHavale = Number(sendData?.sumTahvil?.kasri_havale) || 0;

  return (
    <div ref={ref} className="order__print">
      {/* کارت اطلاعات سفارش */}
      <div className="print__info__card">
        <div className="print__info__card__grid">
          {sendData?.id_havale && (
            <div className="print__info__card__item">
              <span className="print__info__card__label">کد سفارش:</span>
              <span className="print__info__card__value">
                {sendData?.id_havale}
              </span>
            </div>
          )}
          <div className="print__info__card__item">
            <span className="print__info__card__label">تاریخ و ساعت ثبت:</span>
            <span className="print__info__card__value">{`${sendData?.date_sabt}, ${sendData?.time_sabt}`}</span>
          </div>
          <div className="print__info__card__item">
            <span className="print__info__card__label">کاربر ثبت کننده:</span>
            <span className="print__info__card__value">
              {sendData?.name_moshtari}
            </span>
          </div>
          {sendData?.status && (
            <div className="print__info__card__item">
              <span className="print__info__card__label">وضعیت:</span>
              <span className="print__info__card__value">
                {sendData?.status}
              </span>
            </div>
          )}
          <div className="print__info__card__item">
            <span className="print__info__card__label">نام مشتری:</span>
            <span className="print__info__card__value">
              {sendData?.name_moshtari}
            </span>
          </div>
          <div className="print__info__card__item">
            <span className="print__info__card__label">موبایل مشتری:</span>
            <span className="print__info__card__value">
              {sendData?.mobile_moshtari}
            </span>
          </div>
          <div className="print__info__card__item">
            <span className="print__info__card__label">
              تاریخ و ساعت آماده سازی:
            </span>
            <span className="print__info__card__value">{`${sendData?.date_amade}, ${sendData?.time_amade}`}</span>
          </div>
          <div className="print__info__card__item">
            <span className="print__info__card__label">
              تاریخ و ساعت تحویل:
            </span>
            <span className="print__info__card__value">{`${sendData?.date_tahvil}, ${sendData?.time_tahvil}`}</span>
          </div>
          <div
            style={{ gridColumn: "1 / -1" }}
            className="print__info__card__item"
          >
            <span className="print__info__card__label">آدرس:</span>
            <span className="print__info__card__value">
              {`${sendData?.state}، ${sendData?.city}، ${sendData?.address}`}
            </span>
          </div>
        </div>
      </div>

      {/* جدول محصولات */}
      <div className="print__header">
        <h3>لیست محصولات</h3>
      </div>
      <div className="table__section">
        <table className="styled__table">
          <thead>
            <tr>
              <th style={{ width: "40%" }}>نام محصول</th>
              <th style={{ width: "20%" }}>قیمت مصرف کننده</th>
              <th style={{ width: "20%" }}>قیمت فروش</th>
              <th style={{ width: "20%" }}>تعداد</th>
            </tr>
          </thead>
          <tbody>
            {sendData?.products?.map((product, i) => (
              <tr key={i}>
                <td>{product.product_name}</td>
                <td>{Number(product.gh_masraf).toLocaleString()}</td>
                <td>{Number(product.gh_forosh).toLocaleString()}</td>
                <td>{Number(product.te).toLocaleString()}</td>
              </tr>
            ))}
            <tr className="bold">
              <td>مجموع کل</td>
              <td>{productTotal.gh_masraf.toLocaleString()}</td>
              <td>{productTotal.gh_forosh.toLocaleString()}</td>
              <td>{productTotal.te.toLocaleString()}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* جدول خدمات */}
      <div className="print__header">
        <h3>لیست خدمات</h3>
      </div>
      <div className="table__section">
        <table className="styled__table">
          <thead>
            <tr>
              <th style={{ width: "80%" }}>نام خدمت</th>
              <th style={{ width: "20%" }}>مبلغ خدمت</th>
            </tr>
          </thead>
          <tbody>
            {sendData?.services?.map((service, i) => (
              <tr key={i}>
                <td>{service.service_name}</td>
                <td>{Number(service.price).toLocaleString()}</td>
              </tr>
            ))}
            <tr className="bold">
              <td>مجموع کل</td>
              <td>{serviceTotal.toLocaleString()}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* جدول وسایل نقلیه */}
      <div className="print__header">
        <h3>لیست وسایل نقلیه</h3>
      </div>
      <div className="table__section">
        <table className="styled__table">
          <thead>
            <tr>
              <th style={{ width: "33%" }}>پلاک</th>
              <th style={{ width: "33%" }}>نوع ماشین</th>
              <th style={{ width: "33%" }}>شماره تماس</th>
            </tr>
          </thead>
          <tbody>
            {sendData?.cars?.map((car, i) => (
              <tr key={i}>
                <td>{car.pelak}</td>
                <td>{car.car_name}</td>
                <td>{car.driver_mobile}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* بخش مجموع‌ها */}
      <div className="total__section">
        <div className="total__card">
          <div className="total__header">
            <h3>مجموع سفارش‌ها</h3>
          </div>
          <div className="total__content">
            <p className="total__row">
              مجموع سفارش: <strong>{totalOrder.toLocaleString()}</strong>
            </p>
            <p className="total__row">
              مبلغ مالیات: <strong>{tax.toLocaleString()}</strong>
            </p>
            <p className="total__row">
              مبلغ قابل پرداخت: <strong>{totalPayable.toLocaleString()}</strong>
            </p>
          </div>
        </div>
        {sendData?.sumTahvil && (
          <div className="total__card">
            <div className="total__header">
              <h3>مجموع تحویل‌شده</h3>
            </div>
            <div className="total__content">
              <p className="total__row">
                مجموع سفارش: <strong>{fiTahvil.toLocaleString()}</strong>
              </p>
              <p className="total__row">
                مبلغ مالیات: <strong>{taxTahvil.toLocaleString()}</strong>
              </p>
              <p className="total__row">
                مبلغ قابل پرداخت:{" "}
                <strong>{totalPayableTahvil.toLocaleString()}</strong>
              </p>
              <p className="total__row">
                مجموع کسری: <strong>{kasriHavale.toLocaleString()}</strong>
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

OrderPrint.displayName = "OrderPrint";
export default OrderPrint;
